export class SvgInjector {
	init(){
		var mySVGsToInject = document.querySelectorAll('img.inject-svg');
	  SVGInjector(mySVGsToInject, {}, function(){
	  	$('.contact-map--transparent path').hover(function(){
      var pathID = $(this).attr('id');
	      $('.contact-map--color path[id="'+pathID+'"]').css({'fill': '#003179'});
	    }, function(){
	      $('.contact-map--color path').css({'fill': 'rgb(210, 220, 237)'});
	    });

	    $('.contact-map--transparent path').on('click', function(){
	      $('.map-infos').hide();
	      let tabID = $(this).attr('id');
	      $('.contact-map--color path').attr('class', 'swisspor-area');
	      $('.contact-map--color path[id="'+tabID+'"]').attr('class', 'swisspor-area active');
	      $('.map-item').hide();
	      $('.map-item[data-tab="'+tabID+'"]').show();
	    });

	    $('.js--regions').on('click', function(){
	      $(this).closest('.map-item__regions').find('.regions-list').slideToggle();
	    });
	  });
	}
}